// extracted by mini-css-extract-plugin
export default {"container":"AppTextInput_container__dDpt9","header":"AppTextInput_header__VULJT","inputContainer":"AppTextInput_inputContainer__OrZZv"};